<!--
 * @Description: 示例分享
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <div
      style="
        width: 420px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 18px;
      "
    >
      <img
        v-for="i in 15"
        :key="i"
        :src="`https://cdn.yxvzb.com/WEB/SaaS/bi-v3/images/hot/${i}.png`"
        style="width: 100%"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

const { curItem } = useDetailCmpt({});
</script>
<style lang="scss" scope></style>
